module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "Create Email Channel",
      "width": "40%",
      "visible": _vm.showDialog,
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-body"
  }, [_c('el-form', {
    ref: "emailChannelForm",
    attrs: {
      "model": _vm.emailChannelForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "email",
      "label": "Email",
      "rules": _vm.emailInputRules
    }
  }, [_c('el-input', {
    attrs: {
      "autofocus": true
    },
    model: {
      value: (_vm.emailChannelForm.email),
      callback: function($$v) {
        _vm.$set(_vm.emailChannelForm, "email", $$v)
      },
      expression: "emailChannelForm.email"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "plain": ""
    },
    on: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.addingEmailChannel,
      "plain": ""
    },
    on: {
      "click": _vm.handleSaveChannel
    }
  }, [_vm._v("\n      Save\n      "), (_vm.addingEmailChannel) ? _c('i', {
    staticClass: "fa fa-spinner fa-pulse"
  }) : _vm._e()])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c6fa82c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/channel/email/EmailChannelCreateDialog.vue
// module id = 3270
// module chunks = 3